import { useState } from 'react';
import { canPredictEarly, PAYMENT_TIER_PLATINUM } from '@mondy/shared';
import { useCurrentUser } from '@/hooks/useCurrentUser';
import { UpgradeModal, type UpgradeReason } from '@/components/UpgradeModal';

// Promo CTA for free / silver / gold users — opens the standard Stripe
// upgrade modal with Platinum highlighted, off the back of the
// EARLY_PREDICTION reason variant. Hidden for users who already have the perk.
export function EarlyPredictionUpgradeCTA({
  variant = 'banner',
}: {
  variant?: 'banner' | 'inline';
}) {
  const user = useCurrentUser();
  const [open, setOpen] = useState(false);

  if (!user) return null;
  if (canPredictEarly(user.paymentTier)) return null;

  const reason: UpgradeReason = {
    code: 'EARLY_PREDICTION',
    requiredTier: PAYMENT_TIER_PLATINUM,
    currentTier: user.paymentTier,
  };

  if (variant === 'inline') {
    return (
      <>
        <button
          type="button"
          onClick={() => setOpen(true)}
          className="btn btn-ghost"
          style={{ alignSelf: 'flex-start' }}
        >
          Upgrade
        </button>
        <UpgradeModal
          open={open}
          onClose={() => setOpen(false)}
          reason={reason}
        />
      </>
    );
  }

  return (
    <>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 12,
          padding: '12px 16px',
          margin: '0 0 16px',
          borderRadius: 'var(--radius-lg)',
          border: '1px solid var(--line)',
          background: 'var(--surface)',
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <span style={{ fontSize: 14, fontWeight: 600 }}>
            Predict early with Platinum
          </span>
          <span style={{ fontSize: 12, color: 'var(--fg-muted)' }}>
            Skip the 24-hour window for any match with confirmed teams.
          </span>
        </div>
        <button
          type="button"
          onClick={() => setOpen(true)}
          className="btn btn-primary"
        >
          Upgrade
        </button>
      </div>
      <UpgradeModal
        open={open}
        onClose={() => setOpen(false)}
        reason={reason}
      />
    </>
  );
}
